import React from 'react';

import {CircularProgress} from "@mui/joy";
import Box from '@mui/joy/Box';

// components
import BaseApi from "../../utils/BaseApi";
import withRouter from "../../utils/withRouter";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import {deleteArrayItemByKeyValue, objectFilter, setArrayKey} from "../../utils/misc";
import MaterialSearchModal from "./MaterialSearchModal";


class MaterialList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            materials: null,
            pages: null,
            filters: {},
            filterFields: null
        };
    }

    async componentDidMount() {
        await this.retrieveMaterials();
        await this.retrieveFilterFields();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveMaterials();
        }
    }

    async retrieveFilterFields() {
        const url = 'material/update_form/';
        const api = new BaseApi();
        let params = {
            fields: JSON.stringify(
                [
                    'xtype',
                    'xformat',
                    'key',
                ]
            )
        }
        let response = await api.get(url, params);
        let formFields = response.data
        formFields = deleteArrayItemByKeyValue(
            formFields,
            'name',
            'submitButton'
        );
        formFields = setArrayKey(
            formFields,
            'name',
            'xtype',
            'required',
            false,
        )
        formFields = setArrayKey(
            formFields,
            'name',
            'xformat',
            'required',
            false,
        )
        this.setState(
            {
                filterFields: formFields,
            }
        );
    }

    async retrieveMaterials() {
        const url = 'material/';
        const api = new BaseApi();
        let params = {}
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        params = {...params, ...this.state.filters};
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        this.setState(
            {
                materials: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    async filterCallBack(filters) {
        filters = objectFilter(
            filters,
            (e) => (e !== '' || !!e)
        )
        await this.setState({
            filters: filters
        });
        await this.retrieveMaterials();
    }

    render() {
        if (!this.state.materials || !this.state.pages || !this.state.filterFields) {
            return (<CircularProgress/>)
        }
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    my: 1,
                    gap: 1,
                    flexWrap: 'wrap',
                    '& > *': {
                        minWidth: 'clamp(0px, (500px - 100%) * 999, 100%)',
                        flexGrow: 1,
                    },
                }}
            >
                <CommonPaginatedTable
                    title={'Материалы'}
                    url={'material'}
                    data={this.state.materials}
                    pages={this.state.pages}
                    pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
                    filterCallBack={this.filterCallBack.bind(this)}
                    filterFields={this.state.filterFields}
                    extraComponents={[
                        {
                            component: MaterialSearchModal,
                            componentProps: {
                            },
                        },
                    ]}
                    fields={[
                        {
                            title: 'Название',
                            name: 'title',
                            linkPattern: '/material/detail/:linkParam',
                            linkParam: 'id',
                            linkTarget: '_blank',
                            visible: true,
                        },
                        {
                            title: 'Ключ',
                            name: 'key',
                            visible: true,
                        },
                        {
                            title: 'Тип',
                            name: 'xtype',
                            visible: true,
                        },
                        {
                            title: 'Формат',
                            name: 'xformat',
                            visible: true,
                        },
                        {
                            title: 'Создано',
                            name: 'created_on',
                            visible: true,
                        },
                    ]
                    }
                />
            </Box>
        )
    }
}

export default withRouter(MaterialList)